import type { CSS } from '@grupoboticario/flora-react'

import { headerHeight } from '@/assets/style/utils'

export const outerFlexCss: CSS = {
  width: '100vw',
  height: '100vh',
  flexDirection: 'column',
  '@desktop': {
    flexDirection: 'row'
  }
}

export const sidebarCss: CSS = {
  backgroundColor: '$actionableDefault',
  height: headerHeight,
  '@desktop': { flexGrow: '3', height: 'auto' }
}

export const logoImageCss: CSS = {
  height: '40px',
  width: '188px',
  '@desktop': { height: 'auto', width: 'auto' }
}

export const contentFlexCss: CSS = {
  flexGrow: '2'
}

export const contentBoxCss: CSS = {
  maxWidth: '380px',
  textAlign: 'center'
}

export const loginButtonRowCss: CSS = {
  marginTop: '$6'
}

export const loginImageCss: CSS = {
  cursor: 'pointer'
}

export const testUsersRowCss: CSS = {
  marginTop: '$8'
}
